import { extractData } from '@/models';
import api from '@/services/api';
import type { Currency, Rate } from '@/types';

const apiUrl = PROCESSING_API_URL;

export default {
    crypto(currency: Currency) {
        return api()
            .get<Rate[]>(`${ apiUrl }/public/processing/v1/exchange-rates/crypto`, {
                params: {
                    target: currency,
                },
            })
            .then(extractData);
    },
};
